import { shareOrigin } from "@/lib/origin";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

export const fill = (t, vals) => Object.entries(vals).reduce((s, [k, v]) => s.split(`{${k}}`).join(v ?? ""), t || "");

export const personalLink = (slug, ch) => `${shareOrigin()}/${slug}${ch ? `?ch=${ch}` : ""}`;

// One tap: native share sheet on phones, clipboard elsewhere. Logs a partner share when asked.
export async function shareOut({ text, url, title = "Xcelio", log }) {
  try {
    if (navigator.share) await navigator.share({ title, text, ...(url ? { url } : {}) });
    else { await navigator.clipboard.writeText(url && !text.includes(url) ? `${text} ${url}` : text); toast.success("Copied. Paste it anywhere."); }
    if (log) api.post("/partner/shared", log).catch(() => {});
    return true;
  } catch (e) {
    if (e?.name !== "AbortError") toast.error("Couldn't share that. Please try again.");
    return false;
  }
}

export async function copyOut(text, log) {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Copied");
    if (log) api.post("/partner/shared", log).catch(() => {});
  } catch { toast.error("Copy failed. Long-press the text instead."); }
}
